<template>
    <div class="instructions">
        <div
            :class="{ instructions__header: true, 'instructions__header--expanded': !isExpanded }"
            @click="isExpanded = !isExpanded"
        >
            Как заработать баллы?

            <ExpandIcon
                class="instructions__header-icon"
                :style="{ transform: !isExpanded ? 'rotate(270deg)' : 'rotate(90deg)' }"
            />
        </div>

        <div class="instructions__content" v-if="isExpanded">
            <div class="instructions__content-item">
                <span class="instructions__content-item-text"
                    ><span class="instructions__content-item-number">1.</span> Отправляй пригласительную
                    <br v-if="isMobile" />
                    ссылку друзьям,
                    <br v-if="!isMobile" />
                    которые еще <br v-if="isMobile" />
                    не зарегистрированы на <a href="https://rsv.ru" target="_blank">rsv.ru</a>
                </span>
            </div>

            <div class="instructions__content-item">
                <span class="instructions__content-item-text">
                    <span class="instructions__content-item-number">2.</span> Получай баллы за их активное
                    <br v-if="isMobile" />
                    участие в проектах <br v-if="!isMobile" />
                    платформы <br v-if="isMobile" /> «Россия — страна возможностей»
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ExpandIcon from './icons/ExpandIcon.vue';

export default {
    name: 'RefInstruction',

    components: {
        ExpandIcon,
    },

    computed: {
        ...mapGetters(['isMobile']),
    },

    data() {
        return {
            isExpanded: false,
        };
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.instructions {
    width: 100%;
    font-weight: 500;
    color: #000;
    font-size: urem(14);
    line-height: urem(20);
    width: 100%;
    background: rgba(247, 248, 250, 1);
    border-radius: urem(16);

    &__header {
        font-size: urem(14);
        font-weight: 600;
        color: rgba(105, 96, 159, 1);
        line-height: urem(24);
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(225, 223, 236, 1);

        border-top-left-radius: urem(16);
        border-top-right-radius: urem(16);
        height: urem(38);
        cursor: pointer;

        &--expanded {
            border-radius: urem(16);
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: urem(16) urem(16) urem(24) urem(16);
        background-color: rgba(247, 248, 250, 1);
        border-bottom-left-radius: urem(16);
        border-bottom-right-radius: urem(16);
    }

    &__content-item {
        display: flex;
        align-items: center;
        justify-content: center;

        margin-bottom: urem(10);
    }

    &__content-item-number {
        font-size: urem(14);
        font-weight: 700;
        color: rgba(105, 96, 159, 1);
        margin-right: urem(6);
    }

    &__content-item-text {
        font-size: urem(14);
        font-weight: 500;
        color: #000;

        a {
            color: rgba(70, 99, 171, 1);
            text-decoration: underline;
        }
    }

    &__header-icon {
        width: urem(7);
        height: urem(12);
        margin-left: urem(6);
        transform: rotate(90deg);

        @include on-desktop {
            width: urem(12);
        }
    }
}
</style>
